const defaultState = {
  viewKiloDiarioModal: false,
  viewMetaMensualModal: false,
};

function reducer(state = defaultState, { type, payload }) {
  switch (type) {
    case "VIEW_KILO_DIARIO_MODAL": {
      return { ...state, viewKiloDiarioModal: payload };
    }
    case "VIEW_META_MENSUAL_MODAL": {
      return { ...state, viewMetaMensualModal: payload };
    }   
    default:
      return state;
  }
}

export default reducer;